import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ConfigProvider, Input, InputNumber, Select, theme } from 'antd';
import classNames from 'classnames';
import useMergedState from 'rc-util/es/hooks/useMergedState';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { HexColorPicker, RgbaColorPicker } from 'react-colorful';
import tinycolor from 'tinycolor2';
import makeStyle from "./utils/makeStyle";
var useToken = theme.useToken;
var useStyle = makeStyle('ColorPanel', function (token) {
  return {
    '.color-panel': {
      padding: 12,
      backgroundColor: '#fff',
      borderRadius: 12,
      border: '1px solid rgba(0, 0, 0, 0.06)',
      boxShadow: token.boxShadow,
      width: 224,
      boxSizing: 'border-box',
      '.color-panel-mode': {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 6
      },
      '.color-panel-preview': {
        width: 24,
        height: 24,
        borderRadius: 4,
        boxShadow: '0 2px 3px -1px rgba(0,0,0,0.20), inset 0 0 0 1px rgba(0,0,0,0.09)',
        flex: 'none',
        overflow: 'hidden',
        background: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAFpJREFUWAntljEKADAIA23p6v//qQ+wfUEcCu1yriEgp0FHRJSJcnehmmWm1Dv/lO4HIg1AAAKjTqm03ea88zMCCEDgO4HV5bS757f+7wRoAAIQ4B9gByAAgQ3pfiDmXmAeEwAAAABJRU5ErkJggg==) 0% 0% / 32px'
      },
      '.color-panel-preset-colors': {
        paddingTop: 12,
        display: 'flex',
        flexWrap: 'wrap',
        width: 200
      },
      '.color-panel-preset-color-btn': {
        borderRadius: 4,
        width: 20,
        height: 20,
        border: 'none',
        outline: 'none',
        margin: 4,
        cursor: 'pointer',
        boxShadow: '0 2px 3px -1px rgba(0,0,0,0.20), inset 0 0 0 1px rgba(0,0,0,0.09)'
      },
      '.color-panel-mode-title': {
        color: token.colorTextPlaceholder,
        marginTop: 2,
        fontSize: 12,
        textAlign: 'center'
      },
      '.color-panel-rgba-input': {
        display: 'flex',
        alignItems: 'center',
        '&-part': _defineProperty({
          flex: 1,
          width: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          '&-title': {
            color: token.colorTextPlaceholder,
            marginTop: 2,
            fontSize: 12
          },
          '&:not(:last-child)': {
            marginRight: 4
          }
        }, "".concat(token.rootCls, "-input-number"), {
          width: '100%',
          input: {
            fontSize: 12,
            padding: '0 4px'
          }
        })
      }
    }
  };
});

var getHexValue = function getHexValue(value) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return alpha ? tinycolor(value).toHex8() : tinycolor(value).toHex();
};

var HexColorInput = function HexColorInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      alpha = _ref.alpha;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      hexValue = _useState2[0],
      setHexValue = _useState2[1];

  var focusRef = useRef(false);

  var handleChange = function handleChange(e) {
    setHexValue(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(getHexValue(e.target.value, alpha));
  };

  var handleBlur = function handleBlur(e) {
    focusRef.current = false;
    setHexValue(getHexValue(e.target.value, alpha));
  };

  var handleFocus = function handleFocus() {
    focusRef.current = true;
  };

  useEffect(function () {
    if (!focusRef.current) {
      setHexValue(getHexValue(value, alpha));
    }
  }, [value, alpha]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
    prefix: "#",
    size: "small",
    value: hexValue,
    onFocus: handleFocus,
    onChange: handleChange,
    onBlur: handleBlur
  }), /*#__PURE__*/React.createElement("div", {
    className: "color-panel-mode-title"
  }, "HEX", alpha ? '8' : ''));
};

var RgbColorInput = function RgbColorInput(_ref2) {
  var customValue = _ref2.value,
      onChange = _ref2.onChange,
      alpha = _ref2.alpha;

  var _useMergedState = useMergedState(customValue !== null && customValue !== void 0 ? customValue : {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  }, {
    value: customValue,
    onChange: onChange
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      value = _useMergedState2[0],
      setValue = _useMergedState2[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "color-panel-rgba-input"
  }, /*#__PURE__*/React.createElement(ConfigProvider, {
    theme: {
      components: {
        InputNumber: {
          handleWidth: 12
        }
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "color-panel-rgba-input-part"
  }, /*#__PURE__*/React.createElement(InputNumber, {
    min: 0,
    max: 255,
    size: "small",
    value: value.r,
    onChange: function onChange(v) {
      return setValue(_objectSpread(_objectSpread({}, value), {}, {
        r: v !== null && v !== void 0 ? v : 0
      }));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "color-panel-mode-title"
  }, "R")), /*#__PURE__*/React.createElement("div", {
    className: "color-panel-rgba-input-part"
  }, /*#__PURE__*/React.createElement(InputNumber, {
    min: 0,
    max: 255,
    size: "small",
    value: value.g,
    onChange: function onChange(v) {
      return setValue(_objectSpread(_objectSpread({}, value), {}, {
        g: v !== null && v !== void 0 ? v : 0
      }));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "color-panel-mode-title"
  }, "G")), /*#__PURE__*/React.createElement("div", {
    className: "color-panel-rgba-input-part"
  }, /*#__PURE__*/React.createElement(InputNumber, {
    min: 0,
    max: 255,
    size: "small",
    value: value.b,
    onChange: function onChange(v) {
      return setValue(_objectSpread(_objectSpread({}, value), {}, {
        b: v !== null && v !== void 0 ? v : 0
      }));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "color-panel-mode-title"
  }, "B")), alpha && /*#__PURE__*/React.createElement("div", {
    className: "color-panel-rgba-input-part"
  }, /*#__PURE__*/React.createElement(InputNumber, {
    min: 0,
    max: 1,
    step: 0.01,
    size: "small",
    value: value.a,
    onChange: function onChange(v) {
      return setValue(_objectSpread(_objectSpread({}, value), {}, {
        a: v !== null && v !== void 0 ? v : 0
      }));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "color-panel-mode-title"
  }, "A"))));
};

var colorModes = ['HEX', 'HEX8', 'RGB', 'RGBA'];

var getColorStr = function getColorStr(color, mode) {
  switch (mode) {
    case 'HEX':
      return tinycolor(color).toHexString();

    case 'HEX8':
      return tinycolor(color).toHex8String();

    case 'RGBA':
    case 'RGB':
    default:
      return tinycolor(color).toRgbString();
  }
};

var ColorPanel = function ColorPanel(_ref3) {
  var color = _ref3.color,
      _onChange = _ref3.onChange,
      alpha = _ref3.alpha,
      style = _ref3.style;

  var _useToken = useToken(),
      token = _useToken.token;

  var _useStyle = useStyle(),
      _useStyle2 = _slicedToArray(_useStyle, 2),
      wrapSSR = _useStyle2[0],
      hashId = _useStyle2[1];

  var _React$useState = React.useState('HEX'),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      colorMode = _React$useState2[0],
      setColorMode = _React$useState2[1];

  var presetColors = useMemo(function () {
    return [token.blue, token.purple, token.cyan, token.green, token.magenta, token.pink, token.red, token.orange, token.yellow, token.volcano, token.geekblue, token.gold, token.lime, '#000'];
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  var handleColorModeChange = function handleColorModeChange(value) {
    setColorMode(value);

    _onChange(getColorStr(color, value));
  };

  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: classNames(hashId, 'color-panel'),
    style: style
  }, (colorMode === 'HEX' || colorMode === 'RGB') && /*#__PURE__*/React.createElement(HexColorPicker, {
    style: {
      height: 160
    },
    color: tinycolor(color).toHex(),
    onChange: function onChange(value) {
      _onChange(getColorStr(value, colorMode));
    }
  }), (colorMode === 'RGBA' || colorMode === 'HEX8') && /*#__PURE__*/React.createElement(RgbaColorPicker, {
    style: {
      height: 160
    },
    color: tinycolor(color).toRgb(),
    onChange: function onChange(value) {
      _onChange(getColorStr(value, colorMode));
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "color-panel-mode"
  }, /*#__PURE__*/React.createElement("div", {
    className: "color-panel-preview"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: color,
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/React.createElement(Select, {
    value: colorMode,
    onChange: handleColorModeChange,
    options: colorModes.filter(function (item) {
      return alpha || item === 'HEX' || item === 'RGB';
    }).map(function (item) {
      return {
        value: item,
        key: item
      };
    }),
    size: "small",
    bordered: false,
    dropdownMatchSelectWidth: false
  })), colorMode === 'HEX' && /*#__PURE__*/React.createElement(HexColorInput, {
    value: tinycolor(color).toHex(),
    onChange: function onChange(v) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(tinycolor(v).toHexString());
    }
  }), colorMode === 'HEX8' && /*#__PURE__*/React.createElement(HexColorInput, {
    alpha: true,
    value: tinycolor(color).toHex8(),
    onChange: function onChange(v) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(tinycolor(v).toHex8String());
    }
  }), (colorMode === 'RGBA' || colorMode === 'RGB') && /*#__PURE__*/React.createElement(RgbColorInput, {
    alpha: colorMode === 'RGBA',
    value: tinycolor(color).toRgb(),
    onChange: function onChange(v) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(tinycolor(v).toRgbString());
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "color-panel-preset-colors"
  }, presetColors.map(function (presetColor) {
    return /*#__PURE__*/React.createElement("button", {
      key: presetColor,
      className: "color-panel-preset-color-btn",
      style: {
        backgroundColor: presetColor
      },
      onClick: function onClick() {
        return _onChange(presetColor);
      }
    });
  }))));
};

export default ColorPanel;